import React, { Fragment } from "react";

import {
  Divider,
  Grid,
  ListItem,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { Minus as MinusIcon, Plus as PlusIcon } from "react-feather";

import Button from "@ds-developer/button";

import { SkillRowProps } from "./types";

const useStyles = makeStyles(theme => ({
  skillsListItem: {
    height: "60px",
  },
  skillName: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.375rem",
    alignItems: "center",
    display: "flex",
    color: colors.common.black,
  },
  skillScore: {
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    color: colors.blueGrey[600],
  },
  differencePositive: {
    color: colors.green[500],
  },
  differenceNegative: {
    color: colors.red[500],
  },
  button: {
    color: theme.palette.secondary.main,
    alignItems: "center",
    display: "flex",

    "&:hover": {
      backgroundColor: "transparent",
    },

    "&:disabled": {
      color: theme.palette.secondary.main,
      transition: "opacity 0.5s ease-in-out",
      opacity: 0.5,
    },

    "& span": {
      alignItems: "center",
      display: "flex",
    },
  },
}));

const SkillRow: React.FC<SkillRowProps> = ({
  decreaseScore,
  increaseScore,
  skillScore,
  difference,
  skillName,
  enableEdit = false,
}: SkillRowProps) => {
  const classes = useStyles();

  return (
    <Fragment>
      <ListItem className={classes.skillsListItem}>
        <Grid container direction="row">
          <Grid container item xs={5} sm={8}>
            <Typography variant="body1" className={classes.skillName}>
              {skillName}
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={7}
            sm={4}
            direction="row"
            alignItems="center"
            justify="flex-end"
          >
            {difference !== 0 && (
              <Typography
                className={
                  difference > 0
                    ? classes.differencePositive
                    : classes.differenceNegative
                }
              >
                {difference > 0 ? "+" : ""}
                {difference}
              </Typography>
            )}
            {enableEdit && (
              <Button
                onClick={decreaseScore}
                className={classes.button}
                disabled={skillScore < 1}
              >
                <MinusIcon />
              </Button>
            )}
            <Typography variant="body2" className={classes.skillScore}>
              {skillScore}
            </Typography>
            {enableEdit && (
              <Button
                onClick={increaseScore}
                className={classes.button}
                disabled={skillScore > 4}
              >
                <PlusIcon />
              </Button>
            )}
          </Grid>
        </Grid>
      </ListItem>
      <Divider />
    </Fragment>
  );
};

export default SkillRow;
